import React, { useState, useEffect, useContext } from "react";
import { CartContext } from "../context/CartContext";

const PaymentStep = ({ handlePaymentSubmit, paymentData, setPaymentData }) => {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const [discAmnt, setDiscAmnt] = useState(0);
  const [discPr, setDiscPr] = useState(0);

  const { cartItems, temporaryCartItems } = useContext(CartContext);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await handlePaymentSubmit(paymentData);
    } catch (error) {
      console.error("Error submitting payment:", error);
    }
  };

  useEffect(() => {
    const newDate = new Date();
    const priorDate = new Date(newDate);
    priorDate.setDate(newDate.getDate() + 15);

    const year = priorDate.getFullYear();
    const month = (priorDate.getMonth() + 1).toString().padStart(2, "0"); // Adding zero-padding to ensure double-digit month
    const day = priorDate.getDate().toString().padStart(2, "0"); // Adding zero-padding to ensure double-digit day

    const formattedShippingDate = `${year}-${month}-${day}`;

    const totalQuantity = cartItems.reduce(
      (total, item) => total + item.qty,
      0
    );

    const allProductId = cartItems.map((curElem) => {
      return { product_id: curElem.product_id };
    });

    const allProductIdsString = `[${allProductId
      .map((item) => item.product_id)
      .join(", ")}]`;

    setPaymentData({
      product_id_fk: allProductIdsString,
      shipping_date: formattedShippingDate,
      user_id_fk: userId,
      status: 1,
      order_notes: paymentData.order_notes,
      country_code: 90,
      country_id: 100,
      disc_amt: discAmnt,
      disc_pr: discPr,
      total_qty: totalQuantity,
    });
  }, []);

  // console.log("̥paymentData-123", paymentData);
  return (
    <form onSubmit={handleSubmit} className="mx-0">
      <div className="row mt-3">
        <div className="col-md-7">
          <label htmlFor="order_notes" className="form-label">
            Order Notes
          </label>
          <input
            type="text"
            required
            className="form-control"
            id="order_notes"
            value={paymentData.order_notes}
            onChange={(e) =>
              setPaymentData({ ...paymentData, order_notes: e.target.value })
            }
          />
        </div>
        <div className="col-md-5">
          <label htmlFor="shipping_date" className="form-label">
            Shipping To Be Expected (dd-mm-yyyy)
          </label>
          <input
            type="text"
            required
            className="form-control"
            id="shipping_date"
            defaultValue={paymentData.shipping_date}
            disabled
            readOnly
          />
        </div>
        <div className="col-md-4 mt-4">
          <label htmlFor="disc_amnt" className="form-label">
            Discount Amount
          </label>
          <input
            type="text"
            required
            className="form-control"
            id="disc_amnt"
            defaultValue="0"
            onChange={(e) => setDiscAmnt(e.target.value)}
          />
        </div>
        <div className="col-md-4 mt-4">
          <label htmlFor="disc_perc" className="form-label">
            Discount Percentage
          </label>
          <input
            type="text"
            required
            className="form-control"
            id="disc_perc"
            defaultValue="0"
            onChange={(e) => setDiscPr(e.target.value)}
          />
        </div>
      </div>

      {/*<div className="row mt-3">
         <div className="col-md-4">
          <label htmlFor="other_charges_1" className="form-label">
            Other Charges 1
          </label>
          <input
            type="text"
            required
            className="form-control"
            id="other_charges_1"
            value={paymentData.other_charges_1}
            onChange={(e) =>
              setPaymentData({
                ...paymentData,
                other_charges_1: e.target.value,
              })
            }
            disabled
          />
        </div>
        <div className="col-md-4">
          <label htmlFor="other_charges_2" className="form-label">
            Other Charges 2
          </label>
          <input
            type="text"
            required
            className="form-control"
            id="other_charges_2"
            value={paymentData.other_charges_2}
            onChange={(e) =>
              setPaymentData({
                ...paymentData,
                other_charges_2: e.target.value,
              })
            }
            disabled
          />
        </div>
        <div className="col-md-4">
          <label htmlFor="other_charges_3" className="form-label">
            Other Charges 3
          </label>
          <input
            type="text"
            required
            className="form-control"
            id="other_charges_3"
            value={paymentData.other_charges_3}
            onChange={(e) =>
              setPaymentData({
                ...paymentData,
                other_charges_3: e.target.value,
              })
            }
            disabled
          />
        </div> 
      </div>

       <div className="row mt-3">
        <div className="col-md-3">
          <label htmlFor="tax_1" className="form-label">
            Tax 1
          </label>
          <input
            type="text"
            required
            className="form-control"
            id="tax_1"
            value={paymentData.tax_1}
            onChange={(e) =>
              setPaymentData({ ...paymentData, tax_1: e.target.value })
            }
            disabled
          />
        </div>
        <div className="col-md-3">
          <label htmlFor="tax_2" className="form-label">
            Tax 2
          </label>
          <input
            type="text"
            required
            className="form-control"
            id="tax_2"
            value={paymentData.tax_2}
            onChange={(e) =>
              setPaymentData({ ...paymentData, tax_2: e.target.value })
            }
            disabled
          />
        </div>
        <div className="col-md-3">
          <label htmlFor="tax_3" className="form-label">
            Tax 3
          </label>
          <input
            type="text"
            required
            className="form-control"
            id="tax_3"
            value={paymentData.tax_3}
            onChange={(e) =>
              setPaymentData({ ...paymentData, tax_3: e.target.value })
            }
            disabled
          />
        </div>
        <div className="col-md-3">
          <label htmlFor="tax_4" className="form-label">
            Tax 4
          </label>
          <input
            type="text"
            required
            className="form-control"
            id="tax_4"
            value={paymentData.tax_4}
            onChange={(e) =>
              setPaymentData({ ...paymentData, tax_4: e.target.value })
            }
            disabled
          />
        </div>
      </div> 

      <div className="row mt-3">
         <div className="col-md-4">
          <label htmlFor="country_code" className="form-label">
            Country Code
          </label>
          <input
            type="text"
            required
            className="form-control"
            id="country_code"
            value={paymentData.country_code}
            onChange={(e) =>
              setPaymentData({ ...paymentData, country_code: e.target.value })
            }
          />
        </div> 
         <div className="col-md-4">
          <label htmlFor="disc_amt" className="form-label">
            Discounted Amount
          </label>
          <input
            type="text"
            required
            className="form-control"
            id="disc_amt"
            value={paymentData.disc_amt}
            onChange={(e) =>
              setPaymentData({ ...paymentData, disc_amt: e.target.value })
            }
          />
        </div> 
         <div className="col-md-4">
          <label htmlFor="disc_pr" className="form-label">
            Discounted Price
          </label>
          <input
            type="text"
            required
            className="form-control"
            id="disc_pr"
            value={paymentData.disc_pr}
            onChange={(e) =>
              setPaymentData({ ...paymentData, disc_pr: e.target.value })
            }
          />
        </div> 
      </div>*/}

      {/*<div className="row mt-3">
         <div className="col-md-4">
          <label htmlFor="status" className="form-label">
            Status
          </label>
          <input
            type="text"
            required
            className="form-control"
            id="status"
            value={paymentData.status}
            onChange={(e) =>
              setPaymentData({ ...paymentData, status: e.target.value })
            }
          />
        </div>
        <div className="col-md-4">
          <label htmlFor="country_code" className="form-label">
            Country Code
          </label>
          <input
            type="text"
            required
            className="form-control"
            id="country_code"
            value={paymentData.country_code}
            onChange={(e) =>
              setPaymentData({ ...paymentData, country_code: e.target.value })
            }
          />
        </div> */}
      {/* <div className="col-md-4">
          <label htmlFor="total_qty" className="form-label">
            Total Quantity
          </label>
          <input
            type="text"
            required
            className="form-control"
            id="total_qty"
            value={paymentData.total_qty}
            onChange={(e) =>
              setPaymentData({ ...paymentData, total_qty: e.target.value })
            }
          />
        </div> */}
      {/* <div className="col-md-4">
          <label htmlFor="total_price" className="form-label">
            Total Price
          </label>
          <input
            type="text"
            required
            className="form-control"
            id="total_price"
            value={paymentData.total_price}
            onChange={(e) =>
              setPaymentData({ ...paymentData, total_price: e.target.value })
            }
          />
        </div> 
      </div>*/}

      <button type="submit" className="btn btn__primary mt-4">
        Make Payment
      </button>
    </form>
  );
};

export default PaymentStep;
